import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/homeView.vue";
import ProductView from "../views/ProductView.vue";

const productSeo = {
  GrowthIQ: {
    title: "GrowthIQ - Wizz Tech AI Business Intelligence",
    description:
      "GrowthIQ by Wizz Tech helps businesses use AI-driven insights, automation, and digital intelligence to support smarter growth decisions.",
  },
  "Contextual GPT": {
    title: "Contextual GPT - Wizz Tech AI Solution",
    description:
      "Contextual GPT by Wizz Tech helps teams build smarter AI workflows, contextual assistants, and practical business automation.",
  },
  "Inventory Management": {
    title: "Inventory Management - Wizz Tech Product Solution",
    description:
      "Wizz Tech Inventory Management supports scalable stock tracking, operations visibility, and digital inventory workflows.",
  },
};

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "Wizz Tech - Turning Ideas into Digital Reality",
      description:
        "Wizz Tech builds scalable digital products, AI solutions, web and mobile applications, product design, and engineering services.",
    },
  },
  {
    path: "/product/:id",
    name: "product",
    component: ProductView,
    meta: {
      title: "Wizz Tech Product Solutions",
      description:
        "Explore Wizz Tech product solutions for AI, business automation, inventory management, and scalable digital operations.",
    },
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  window.scroll(0, 0);
  next();
});
router.afterEach((to) => {
  const defaultTitle = "Wizz Tech - Turning Ideas into Digital Reality";
  const defaultDescription =
    "Wizz Tech builds scalable digital products, AI solutions, web and mobile applications, product design, and engineering services.";
  const productName = to.params?.id ? String(to.params.id) : "";
  const productMeta = productSeo[productName];
  const title = productMeta?.title || to.meta.title || defaultTitle;
  const description =
    productMeta?.description || to.meta.description || defaultDescription;
  const canonicalPath = to.path === "/" ? "/" : to.path.replace(/\/$/, "");
  const canonicalUrl = `https://wizztech.us${canonicalPath}`;

  document.title = title;

  updateMetaTag("name", "description", description);
  updateMetaTag("property", "og:title", title);
  updateMetaTag("property", "og:description", description);
  updateMetaTag("property", "og:url", canonicalUrl);
  updateMetaTag("name", "twitter:title", title);
  updateMetaTag("name", "twitter:description", description);
  updateCanonical(canonicalUrl);
});

function updateMetaTag(attribute, key, content) {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
}

function updateCanonical(href) {
  let element = document.head.querySelector('link[rel="canonical"]');

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }

  element.setAttribute("href", href);
}

export default router;
